/*绑定手机号*/
/* keepAlive:该页面是否缓存
backHome:回到首页按钮是否显示
*/
export default [
    {
        path: 'site/login',
        name: 'siteLogin',
        meta: {
            title:'登录',
            isShowTab: false,
            keepAlive: false,
        },
        component: () => import('@/views/site/login.vue')
    },
    {
        path: 'site/password-login',
        name: 'sitePasswordLogin',
        meta: {
            title:'登录',
            isShowTab: false,
            keepAlive: false,
        },
        component: () => import('@/views/site/password-login.vue')
    },
    {
        path: 'site/bind',
        name: 'siteBind',
        meta: {
            title:'绑定手机号',
            isShowTab: false,
            keepAlive: false,
        },
        component: () => import('@/views/site/bind.vue')
    },
    {
        path: 'site/country',
        name: 'siteCountry',
        meta: {
            title:'选择手机号归属地',
            isShowTab: false,
            keepAlive: false,
        },
        component: () => import('@/views/site/country.vue')
    },

]